var map = {
	"./amadeus/MasterDetail.json": 1163,
	"./barclays/MasterDetail.json": 1164,
	"./cb911/MasterDetail.json": 1165,
	"./choiceHotels/MasterDetail.json": 1166,
	"./globex/MasterDetail.json": 1167,
	"./kraken/MasterDetail.json": 1168,
	"./lastminute/MasterDetail.json": 1169,
	"./monavate/MasterDetail.json": 1170,
	"./outpayce/MasterDetail.json": 1171,
	"./sofi/MasterDetail.json": 1172
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1162;